import React, { useRef, useEffect, useState } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
// import { AP_Payout_Rms } from "../../Configuration/API_URL";
import axios from "axios";
import { toast } from "react-toastify";
import RoundLoader from "../../Components/Common/RoundRingLoader";
import Loader from "../../Components/Common/Loader";
import { AP_Payout_Banking } from "../../Configuration/API_URL";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm, useFieldArray } from "react-hook-form";
import {
  AESEncryption,
  ApiResDecrypt,
  formatDate,
  getClientsRawData,
  onlyAlphaNumeric,
  onlyNumberEnter,
} from "../../CommonMethhods/CommonMethods";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
// import { onlyNumber } from "../../CommonMethhods/CommonMethods";

function Banking() {
  const storeToken = localStorage.getItem("ssoToken");
  const [bankingTableData, setBankingTableData] = useState([]);
  const [downloadBtnLoader, setDownloadBtn] = useState(false);
  const [insertBtnLoader, setInsertloadBtn] = useState(false);
  const [rejectBtnLoader, setRejectBtnLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [approveOrNot, setApproveOrNot] = useState(false);
  const typeRef = useRef("");

  const handleProductType = (e) => {
    typeRef.current.value = e.target.value;
    setBankingTableData([]);
  };

  //   get Banking detail
  const getBankingDetailList = async (typeView = "grid", apCode) => {
    let payloadValue = {
      type: typeView,
      productType: typeRef.current.value,
      apCode: apCode || "",
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      if (typeRef.current.value === "") {
        toast.error("Please Select Type");
      } else {
        const getBankingList = await axios.post(
          AP_Payout_Banking.GetBankingDetails_URL,
          `"${encPayload}"`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${storeToken}`,
              reserv: 1,
            },
          }
        );
        const res = ApiResDecrypt(getBankingList?.data);
        if (res.status === 0) {
          if (typeView === "excel") {
            window.open(res.data, "_self", "noopener,noreferrer");
            toast.success("Excel download successfully");
          } else if (typeView === "grid") {
            setBankingTableData(res.data.bankBrokerage);
          } else {
            toast.error(res.message);
          }
        }
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong, Please try again later.");
    } finally {
      setDownloadBtn(false);
      setLoader(false);
    }
  };

  useEffect(() => {
    // if (typeRef.current.value !== "") {
    setLoader(true);
    getBankingDetailList("grid");
    // }
  }, []);
  //end get details

  //   // update Deduction table

  const insertBankingDetail = async (new_users) => {
    let payloadValue = { bankingList: new_users };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getBankingList = await axios.post(
        AP_Payout_Banking.InsertBankingDetails_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getBankingList?.data);
      if (res.status === 0) {
        toast.success(res.data);
        getBankingDetailList("grid");
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      // toast.error("Something went wrong, Please try again later.");
    } finally {
      setInsertloadBtn(false);
      setRejectBtnLoader(false);
    }
  };

  const approveInsertBtn = async () => {
    let bankingFinalData = { ...getValues() };
    let individualTrue = document.querySelectorAll(".activeData");

    let SubmitArray = [];
    for (let individualdata of individualTrue) {
      if (individualdata.checked && individualdata.disabled != true) {
        const data = bankingFinalData.BankingKey[`${individualdata.id}`];
        // if (data.utrNo !== "") {
        //   if (data.utrNo.length < 16) {
        //     toast.error(`UTR No should be minimum 16 digit ${data.apCode}`);
        //     return;
        //   }
        // } else if (data.utrNo === "") {
        //   toast.error(`Enter UTR No for ${data.apCode}`);
        //   return;
        // }
        // delete data.accountNo;
        // delete data.apName;
        // delete data.apRegistered;
        // delete data.bankName;
        // delete data.brokPayMonth;
        // delete data.brokerage;
        // delete data.classApCd;
        // delete data.deductionAmount;
        // delete data.finalAmount;
        // delete data.financeDeduction;
        // delete data.ifscCode;
        // delete data.ledgerBal;
        // delete data.lessTDS;
        // delete data.netPayout;
        // delete data.netRisk;
        // delete data.pan;
        // delete data.payoutAfterTDS;
        // data.bankingApprove = JSON.parse(data.bankingApprove);

        const filteredData = {
          apCode: data?.apCode || "",
          bankingStatus: "Approved",
          bankingRemarks: data?.bankingRemarks || ""
      };
        SubmitArray.push(filteredData);
      }
    }

    if (SubmitArray.length == 0) {
      toast.error("Choose atleast 1 item to Approve");
      return;
    }
    setInsertloadBtn(true);
    insertBankingDetail(SubmitArray);
  };

  const rejectInsertBtn = async () => {
    let remarkValue;
    let bankingFinalData = { ...getValues() };
    let individualTrue = document.querySelectorAll(".activeData");

    let SubmitArray = [];
    for (let individualdata of individualTrue) {
      if (individualdata.checked && individualdata.disabled != true) {
        const data = bankingFinalData.BankingKey[`${individualdata.id}`];
        remarkValue = getValues(`BankingKey.${individualdata.id}.bankingRemarks`) || "";

        // if (data.utrNo !== "") {
        //   if (data.utrNo.length < 16) {
        //     toast.error(`UTR No should be minimum 16 digit ${data.apCode}`);
        //     return;
        //   }
        // } else if (data.utrNo === "") {
        //   toast.error(`Enter UTR No for ${data.apCode}`);
        //   return;
        // }
        // delete data.accountNo;
        // delete data.apName;
        // delete data.apRegistered;
        // delete data.bankName;
        // delete data.brokPayMonth;
        // delete data.brokerage;
        // delete data.classApCd;
        // delete data.deductionAmount;
        // delete data.finalAmount;
        // delete data.financeDeduction;
        // delete data.ifscCode;
        // delete data.ledgerBal;
        // delete data.lessTDS;
        // delete data.netPayout;
        // delete data.netRisk;
        // delete data.pan;
        // delete data.payoutAfterTDS;
        // data.bankingApprove = JSON.parse(data.bankingApprove);
        const filteredData = {
          apCode: data?.apCode || "",
          bankingStatus: "Rejected",
          bankingRemarks: remarkValue || data?.bankingRemarks || ""
      };
        SubmitArray.push(filteredData);
      }
    }

    if (SubmitArray.length == 0) {
      toast.error("Choose atleast 1 item to Reject");
      return;
    }

    if(remarkValue?.length > 0){
      setRejectBtnLoader(true);
      insertBankingDetail(SubmitArray);
    }else{
      toast.error("Please enter rejecting Remarks");
      setRejectBtnLoader(false);
    }
    
  };

  //   //end update

  const BankingSchema = Yup.object().shape({
    BankingKey: Yup.array().of(
      Yup.object().shape({
        apCode: Yup.string(),
        classApCd: Yup.number(),
        apName: Yup.string(),
        apRegistered: Yup.string(),
        exchange: Yup.string(),
        pan: Yup.string(),
        brokerage: Yup.string(),
        lessTDS: Yup.string(),
        payoutAfterTDS: Yup.string(),
        ledgerBal: Yup.string(),
        netRisk: Yup.string(),
        netPayout: Yup.string(),
        deductionAmount: Yup.string(),
        financeDeduction: Yup.string(),
        finalAmount: Yup.string(),
        accountNo: Yup.string(),
        ifscCode: Yup.string(),
        bankName: Yup.string(),
        utrNo: Yup.string().required("UTR NO. is Required"),
        bankingApprove: Yup.boolean().required("Select a row"),
      })
    ),
  });

  const optionsDf = {
    resolver: yupResolver(BankingSchema),
  };
  const {
    control,
    formState,
    handleSubmit,
    register,
    watch,
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
  } = useForm(optionsDf);
  const { errors } = formState;
  const { fields: bankingField } = useFieldArray({
    name: "BankingKey",
    control,
  });

  useEffect(() => {
    reset({
      BankingKey: bankingTableData,
    });
  }, [bankingTableData]);

  const handleType = () => {
    setDownloadBtn(true);
    getBankingDetailList("excel");
  };
  const downloadEachRecord = (apcode) => {
    if (typeRef.current.value !== "" && apcode != null) {
      // setDownloadBtn(true);
      getBankingDetailList("excel", apcode);
    }
  };

  const singleInputChange = (e) => {
    if (e.target.checked) {
      let AllCheck = [];
      let individualTrue = document.querySelectorAll(".activeData");
      for (let data of individualTrue) {
        AllCheck.push(data.checked);
      }
      if (AllCheck.includes(false)) {
        document.getElementById("select-all-banking").checked = false;
      } else {
        document.getElementById("select-all-banking").checked = true;
      }
    } else {
      document.getElementById("select-all-banking").checked = e.target.checked;
    }
  };
  const selectAllChange = (e) => {
    let individualTrue = document.querySelectorAll(".activeData");
    for (let data of individualTrue) {
      data.checked = e.target.checked;
    }
  };

  const OnChangesForUtr = (e) => {
    e.table.value = e.target.value.toUpperCase();
  };

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="banking-wrapper">
        <div className="card-box">
          <div className="tableHead">
            <h4 className="banking-title">Banking</h4>
          </div>
          <form className="row input-field-wrapper">
            <div className="col-md-3 col-sm-6 col-12">
              <div className="form-group">
                <select
                  className="report-custom-select product-select"
                  // onChange={handleProductType}
                  ref={typeRef}
                >
                  {/* <option value="">--Select Type--</option> */}
                  <option
                    value="brokerage"
                    defaultChecked
                    style={{ display: "none" }}
                  >
                    Brokerage
                  </option>
                  {/* <option value="mtf/las">MTF</option>
                  <option value="amc">AMC</option>
                  <option value="slab wise">Slab Wise</option> */}
                </select>
              </div>
            </div>
          </form>
          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : typeRef.current.value !== "" ? (
            <>
              <div className="d-flex justify-content-end">
                <button
                  className="downloadBtnbanking1"
                  onClick={() => getClientsRawData()}
                >
                  Raw Download
                </button>
                <button className="downloadBtnbanking" onClick={handleType}>
                  {downloadBtnLoader ? (
                    <div className="download-loader">
                      <RoundLoader h={"20"} />
                    </div>
                  ) : (
                    "Download"
                  )}
                </button>
              </div>

              <div className="scroll-table banking-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col" className="text-center">
                        {
                          <input
                            type="checkbox"
                            id="select-all-banking"
                            onChange={(e) => selectAllChange(e)}
                          />
                        }
                      </th>
                      <th scope="col">AP Code</th>
                      <th scope="col">SAP Code</th>
                      <th scope="col" className="">
                        AP Name
                      </th>
                      <th scope="col">Period From</th>
                      <th scope="col">Period To</th>
                      <th scope="col">Module</th>
                      <th scope="col">Pan No</th>
                      <th scope="col">GST No</th>
                      <th scope="col">Actual Gross Brokerage</th>
                      <th scope="col">Gross Brokerage</th>
                      <th scope="col">AP Sharing %</th>
                      <th scope="col">Net Brokerage</th>
                      <th scope="col">GST 18%</th>
                      <th scope="col">Total Invoice</th>
                      <th scope="col">TDS 5%</th>
                      <th scope="col">AP Ledger</th>
                      <th scope="col">AP Risk</th>
                      <th scope="col">Airtel Charges</th>
                      <th scope="col">Deposit to be Adjusted</th>
                      <th scope="col">Deposit Amount</th>
                      <th scope="col">AP AMC</th>
                      <th scope="col">Other Deductions FR</th>
                      <th scope="col">Other Deductions Fin</th>
                      <th scope="col">Final Payout</th>
                      <th scope="col">NSE Registered</th>
                      <th scope="col">BSE Registered</th>
                      <th scope="col">Franchisee Team Approval Status</th>
                      <th scope="col">Franchisee Team Remarks</th>
                      <th scope="col">RMS Team Approval Status</th>
                      <th scope="col">RMS Team Remarks</th>
                      <th scope="col">Finance Team Approval Status</th>
                      <th scope="col">Finance Team Remarks</th>
                      <th scope="col">Banking Team Approval Status</th>
                      <th scope="col">Banking Team Remarks</th>

                      {/* <th scope="col">Download</th> */}
                    </tr>
                  </thead>

                  <tbody>
                    {" "}
                    {bankingField.map((item, i) => (
                      <tr key={i}>
                        <td>
                          <div>
                            <input
                              className={`form-check-input ${
                                getValues(`BankingKey.${i}.bankingStatus`) === "Approved"
                                  ? "inActive"
                                  : "activeData"
                              }`}
                              defaultChecked={getValues(`BankingKey.${i}.bankingStatus`) === "Approved"}
                              disabled={getValues(`BankingKey.${i}.bankingStatus`) === "Approved"}
                              type="checkbox"
                              id={i}
                              value={i}
                              onChange={(e) => singleInputChange(e)}
                              // value={item.bankingApprove}
                              // disabled={item.bankingApprove}
                              // {...register(`BankingKey.${i}.bankingApprove`, {
                              //   defaultChecked: item.bankingApprove,
                              //   onChange: (e) => singleInputChange(e),
                              // })}
                            />
                          </div>
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.apCode`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.sapCode`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.apName`)}
                          />
                        </td>
                        <td>
                              <input
                                className="plane-input"
                                readOnly
                                value={
                                  getValues(`BankingKey.${i}.periodFrom`)
                                    ? formatDate(
                                        getValues(
                                          `BankingKey.${i}.periodFrom`
                                        )?.split(" ")[0]
                                      )
                                    : " "
                                }
                                // {...register(`ApPayout.${i}.periodFrom`)}
                              />
                            </td>
                            <td>
                              <input
                                className="plane-input"
                                readOnly
                                value={
                                  getValues(`BankingKey.${i}.periodTo`)
                                    ? formatDate(
                                        getValues(
                                          `BankingKey.${i}.periodTo`
                                        )?.split(" ")[0]
                                      )
                                    : " "
                                }
                                // {...register(`ApPayout.${i}.periodTo`)}
                              />
                            </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.module`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.pan`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.gstNo`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.actualGrossBrokerage`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.grossBrokerage`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.apSharing`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.netBrokerage`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.gst18Perc`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.totalInvoice`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.tds5Perc`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.apLedger`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.apRisk`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.airtelCharges`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.depositToBeAdjusted`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.depositAmt`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.apAMC`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.otherDeductionFR`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.otherDeductionFin`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.finalPayout`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.nseRegistered`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.bseRegistered`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.franchiseeStatus`)}
                          />
                        </td>

                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.franchiseeRemarks`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.rmsStatus`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.rmsRemarks`)}
                          />
                        </td>

                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.financeStatus`)}
                          />
                        </td>
                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.financeRemarks`)}
                          />
                        </td>

                        <td>
                          <input
                            className="plane-input"
                            readOnly
                            {...register(`BankingKey.${i}.bankingStatus`)}
                          />
                        </td>
                        <td>
                            <input
                              className="onChange-field"
                              defaultValue={getValues(`BankingKey.${i}.bankingRemarks`)}
                              {...register(`BankingKey.${i}.bankingRemarks`)}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(/^\s+/, '');
                              }}
                              disabled={getValues(`BankingKey.${i}.bankingStatus`) === "Approved"}
                            />
                          </td>
                        
                        {/* <td>
                          <input
                            className="onChange-field text-uppercase"
                            readOnly={item.bankingApprove}
                            maxLength={30}
                            {...register(`BankingKey.${i}.bankingRemarks`)}
                            onInput={(e) => onlyAlphaNumeric(e)}
                          />
                        </td> */}
                        
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="pt-5" style={{ fontSize: "1.5rem" }}>
                {" "}
                Total No Of Records : {bankingField.length}
              </p>
              <div className="wrap-buttons">
                <div className="approve-reject-btn">
                  <button
                    value="grid"
                    className="approve-btn"
                    onClick={approveInsertBtn}
                  >
                    {insertBtnLoader ? (
                      <div className="download-loader">
                        <RoundLoader h={"10"} />
                      </div>
                    ) : (
                      "Approve"
                    )}
                  </button>
                </div>
                <div className="approve-reject-btn">
                  <button
                    value="grid"
                    className="reject-btn"
                    onClick={rejectInsertBtn}
                  >
                    {rejectBtnLoader ? (
                      <div className="download-loader">
                        <RoundLoader h={"10"} />
                      </div>
                    ) : (
                      "Reject"
                    )}
                  </button>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </main>
    </>
  );
}

export default Banking;
